import { find, groupBy } from "lodash";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import SimpleCard from "../../SimpleCard/SimpleCard";
import { KeywordsByDayWithThematic } from "src/app/types/planning";
import { useIntl } from "react-intl";
import { Site } from "src/app/types/Site";
import { SimpleFormSelectOption } from "../../form/SimpleFormSelect";

export interface IResumeNetlinking {
    months: number;
    moneySite: Site;
    thematicsOptions: SimpleFormSelectOption[];
    kwNetlinking: Array<KeywordsByDayWithThematic & { id?: number }> | undefined | null;
}
export const ResumeNetlinking = (props: IResumeNetlinking) => {
    const { kwNetlinking, moneySite, months, thematicsOptions } = props;

    const { formatMessage } = useIntl();
    const keywordsByMonth = groupBy(kwNetlinking, ({ date }) => {
        if (date?.includes("-")) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("MM/YYYY");
        } else {
            return moment(date, "DD/MM/YYYY").format("MM/YYYY");
        }
    });
    return (
        <Row>
            <Row>
                <Col>
                    <p>
                        {formatMessage(
                            { id: "planning.netlinkingResume" },
                            {
                                domain: moneySite.domain,
                                netlinking: moneySite?.content?.netlinking || 0,
                                months,
                                netlinkingOrder: months * (moneySite?.content?.netlinking || 0),
                            }
                        )}
                    </p>
                </Col>
            </Row>

            <Row>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                    }}
                >
                    {Object.keys(keywordsByMonth)
                        ?.filter((el) => el !== "Invalid date")
                        .map((value: string, indexMonth: number) => (
                            <SimpleCard
                                header={value}
                                cardProps={{
                                    style: {
                                        background: "var(--kt-primary)",
                                        color: "white",
                                        fontWeight: "600",
                                        lineHeight: "1.5rem",
                                    },
                                }}
                                headerProps={{
                                    style: {
                                        fontSize: "18px",
                                        minHeight: "32px",
                                        display: "flex",
                                        alignContent: "center",
                                    },
                                }}
                                key={indexMonth}
                            >
                                <>
                                    {keywordsByMonth[value].map((el, index) => (
                                        <span key={index}>
                                            <span
                                                className={
                                                    el.thematicId === moneySite.thematic.id
                                                        ? "bg-resume-orange"
                                                        : ""
                                                }
                                            >
                                                {el.date} - {el.keyword}{" "}
                                                {el.rd
                                                    ? `(${el.rd?.thematicName}) - 
                                                ${el.rd?.rdName} (${el.rd?.pbnName})`
                                                    : `(${
                                                          find(
                                                              thematicsOptions,
                                                              (thematic) =>
                                                                  thematic.value === el.thematicId
                                                          )?.label
                                                      }) -  ${formatMessage({
                                                          id: "error.noRdFound",
                                                      })}`}
                                            </span>
                                            <br />

                                            <Row>
                                                <Col sm={8} style={{ color: "black" }}>
                                                    {el.link?.url}
                                                </Col>
                                                <Col
                                                    sm={4}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {el.link?.anchor ? `(${el.link?.anchor})` : ""}
                                                </Col>
                                            </Row>

                                            <br />
                                        </span>
                                    ))}
                                </>
                            </SimpleCard>
                        ))}
                </div>
            </Row>
        </Row>
    );
};
